(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  ready(function () {
    var root = document.getElementById('gsd-events-root');
    if (!root) return;
    var url = root.getAttribute('data-events-url');
    if (!url) return;

    function ymd(y, m, d) {
      return y + '-' + String(m).padStart(2, '0') + '-' + String(d).padStart(2, '0');
    }
    function parseKey(key) {
      var p = key.split('-').map(Number);
      return { y: p[0], m: p[1], d: p[2] };
    }
    function monthName(y, m) {
      return new Date(y, m - 1, 1).toLocaleString(undefined, { month: 'long', year: 'numeric' });
    }
    function formatLong(key) {
      var p = parseKey(key);
      return new Date(p.y, p.m - 1, p.d).toLocaleDateString(undefined, {
        weekday: 'long', month: 'long', day: 'numeric', year: 'numeric'
      });
    }
    function escapeHtml(s) {
      return String(s)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }
    function escapeAttr(s) {
      return escapeHtml(s).replace(/'/g, '&#39;');
    }
    function isPastEvent(ev, nowMs, todayKey) {
      if (ev.endISO) {
        var end = Date.parse(ev.endISO);
        if (!isNaN(end)) return end < nowMs;
      }
      if (ev.startISO) {
        var start = Date.parse(ev.startISO);
        if (!isNaN(start) && start < nowMs && !ev.endISO) return true;
      }
      return ev.date < todayKey;
    }

    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('events fetch ' + r.status); return r.json(); })
      .then(function (events) { init(Array.isArray(events) ? events : []); })
      .catch(function () {
        var panel = root.querySelector('[data-day-panel]');
        var list = root.querySelector('[data-upcoming-list]');
        if (panel) panel.innerHTML = '<p class="gsd-day-panel-empty">Could not load events.</p>';
        if (list) list.innerHTML = '<p class="gsd-events-empty">Could not load events.</p>';
        var past = root.querySelector('[data-past-list]');
        if (past) past.innerHTML = '';
      });

    function init(events) {
      var byDate = {};
      events.forEach(function (ev) {
        if (!byDate[ev.date]) byDate[ev.date] = [];
        byDate[ev.date].push(ev);
      });

      var monthLabel = root.querySelector('[data-cal-month-label]');
      var grid = root.querySelector('[data-cal-grid]');
      var panel = root.querySelector('[data-day-panel]');
      var list = root.querySelector('[data-upcoming-list]');
      var prevBtn = root.querySelector('[data-cal-prev]');
      var nextBtn = root.querySelector('[data-cal-next]');

      var today = new Date();
      var todayKey = ymd(today.getFullYear(), today.getMonth() + 1, today.getDate());
      var viewY = today.getFullYear();
      var viewM = today.getMonth() + 1;
      var currentMonthKey = ymd(viewY, viewM, 1).slice(0, 7);
      var monthsWithEvents = {};
      events.forEach(function (ev) { monthsWithEvents[ev.month] = true; });
      if (!monthsWithEvents[currentMonthKey] && events.length) {
        var first = events[0].month.split('-').map(Number);
        viewY = first[0];
        viewM = first[1];
      }

      var selectedDate = null;
      function pickDefaultSelected() {
        var prefix = ymd(viewY, viewM, 1).slice(0, 7);
        if (todayKey.indexOf(prefix) === 0 && byDate[todayKey]) {
          selectedDate = todayKey;
          return;
        }
        var keys = Object.keys(byDate).filter(function (k) { return k.indexOf(prefix) === 0; }).sort();
        selectedDate = keys.length ? keys[0] : null;
      }

      function renderPanel() {
        if (!selectedDate || !byDate[selectedDate]) {
          panel.innerHTML =
            '<p class="gsd-day-panel-label">Selected day</p>' +
            '<p class="gsd-day-panel-empty">Tap a highlighted day to see event details.</p>';
          return;
        }
        var html = '<p class="gsd-day-panel-label">' + escapeHtml(formatLong(selectedDate)) + '</p>';
        byDate[selectedDate].forEach(function (ev) {
          html += '<article class="gsd-event-card" style="margin-bottom:.65rem">';
          html += '<h3 class="gsd-event-title">' + escapeHtml(ev.title) + '</h3>';
          html += '<p class="gsd-event-when">' + escapeHtml(ev.when) + '</p>';
          if (ev.where) html += '<p class="gsd-event-where">' + escapeHtml(ev.where) + '</p>';
          html += '</article>';
        });
        panel.innerHTML = html;
      }

      function renderList() {
        var pastList = root.querySelector('[data-past-list]');
        var pastWrap = root.querySelector('[data-past-wrap]');
        var nowMs = Date.now();
        var prefix = ymd(viewY, viewM, 1).slice(0, 7);
        var monthEvents = events.filter(function (ev) { return ev.month === prefix; });
        var upcoming = monthEvents.filter(function (ev) { return !isPastEvent(ev, nowMs, todayKey); });
        var pastEvents = monthEvents.filter(function (ev) { return isPastEvent(ev, nowMs, todayKey); });

        function fill(target, items, emptyMsg) {
          if (!target) return;
          if (!items.length) {
            target.innerHTML = emptyMsg ? ('<p class="gsd-events-empty">' + emptyMsg + '</p>') : '';
            return;
          }
          var html = '';
          items.forEach(function (ev) {
            var dim = selectedDate && ev.date !== selectedDate ? ' is-dim' : '';
            html += '<article class="gsd-event-card' + dim + '" data-event-date="' + escapeAttr(ev.date) + '">';
            html += '<h3 class="gsd-event-title">' + escapeHtml(ev.title) + '</h3>';
            html += '<p class="gsd-event-when">' + escapeHtml(ev.when) + '</p>';
            if (ev.where) html += '<p class="gsd-event-where">' + escapeHtml(ev.where) + '</p>';
            html += '</article>';
          });
          target.innerHTML = html;
          target.querySelectorAll('[data-event-date]').forEach(function (card) {
            card.style.cursor = 'pointer';
            card.addEventListener('click', function () {
              selectedDate = card.getAttribute('data-event-date');
              renderCalendar();
              renderPanel();
              renderList();
            });
          });
        }

        fill(list, upcoming, 'No upcoming events this month.');
        fill(pastList, pastEvents, '');
        if (pastWrap) {
          pastWrap.hidden = pastEvents.length === 0;
          if (pastEvents.length === 0 && pastList) pastList.innerHTML = '';
        }
      }

      function renderCalendar() {
        monthLabel.textContent = monthName(viewY, viewM);
        var first = new Date(viewY, viewM - 1, 1);
        var startDow = first.getDay();
        var daysInMonth = new Date(viewY, viewM, 0).getDate();
        var prevDays = new Date(viewY, viewM - 1, 0).getDate();
        var cells = [];
        var i;
        for (i = 0; i < startDow; i++) {
          var dd = prevDays - startDow + i + 1;
          var ppm = viewM === 1 ? 12 : viewM - 1;
          var ppy = viewM === 1 ? viewY - 1 : viewY;
          cells.push({ y: ppy, m: ppm, d: dd, other: true });
        }
        for (i = 1; i <= daysInMonth; i++) {
          cells.push({ y: viewY, m: viewM, d: i, other: false });
        }
        var need = (7 - (cells.length % 7)) % 7;
        var nnm = viewM === 12 ? 1 : viewM + 1;
        var nny = viewM === 12 ? viewY + 1 : viewY;
        for (i = 1; i <= need; i++) {
          cells.push({ y: nny, m: nnm, d: i, other: true });
        }

        var html = '';
        ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].forEach(function (d) {
          html += '<div class="gsd-cal-dow" aria-hidden="true">' + d + '</div>';
        });
        cells.forEach(function (cell) {
          var key = ymd(cell.y, cell.m, cell.d);
          var has = !!byDate[key];
          var cls = 'gsd-cal-day';
          if (cell.other) cls += ' is-other';
          if (key === todayKey) cls += ' is-today';
          if (has) cls += ' has-event';
          if (selectedDate === key) cls += ' is-selected';
          var aria = formatLong(key) + (has ? ', ' + byDate[key].length + ' event' + (byDate[key].length > 1 ? 's' : '') : '');
          if (has) {
            html += '<button type="button" class="' + cls + '" data-date="' + key + '" aria-label="' + escapeAttr(aria) + '">';
            html += '<span>' + cell.d + '</span><span class="gsd-cal-dot" aria-hidden="true"></span></button>';
          } else {
            html += '<div class="' + cls + '" aria-hidden="' + (cell.other ? 'true' : 'false') + '"><span>' + cell.d + '</span></div>';
          }
        });
        grid.innerHTML = html;
        grid.querySelectorAll('button[data-date]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            selectedDate = btn.getAttribute('data-date');
            var p = parseKey(selectedDate);
            if (p.y !== viewY || p.m !== viewM) {
              viewY = p.y;
              viewM = p.m;
            }
            renderCalendar();
            renderPanel();
            renderList();
          });
        });
      }

      prevBtn.addEventListener('click', function () {
        viewM -= 1;
        if (viewM < 1) { viewM = 12; viewY -= 1; }
        pickDefaultSelected();
        renderCalendar();
        renderPanel();
        renderList();
      });
      nextBtn.addEventListener('click', function () {
        viewM += 1;
        if (viewM > 12) { viewM = 1; viewY += 1; }
        pickDefaultSelected();
        renderCalendar();
        renderPanel();
        renderList();
      });

      pickDefaultSelected();
      renderCalendar();
      renderPanel();
      renderList();
    }
  });
})();
